export function getErrorCode(error: unknown): string | undefined {
  return (error as { response?: { data?: { code?: string } } })?.response?.data?.code
}

export function getErrorMessage(error: unknown): string | undefined {
  return (error as { response?: { data?: { message?: string } } })?.response?.data?.message
}

export function getErrorStatus(error: unknown): number | undefined {
  return (error as { response?: { status?: number } })?.response?.status
}

const NON_RETRYABLE_STATUSES = [400, 403, 404]

export function shouldNotRetryRequest(error: unknown): boolean {
  const status = getErrorStatus(error)
  return status !== undefined && NON_RETRYABLE_STATUSES.includes(status)
}
